'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StorageType = undefined;

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _jsCookie = require('js-cookie');

var _jsCookie2 = _interopRequireDefault(_jsCookie);

var _isFunction = require('lodash/isFunction');

var _isFunction2 = _interopRequireDefault(_isFunction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StorageType = exports.StorageType = {
  COOKIE_STORAGE: 'cookieStorage',
  LOCAL_STORAGE: 'localStorage',
  SESSION_STORAGE: 'sessionStorage'

  /**
   * Cookie Storage class for consuming Cookies from js-cookie lib to be used in StorageProxy.
   */
};
var CookieStorage = function () {
  function CookieStorage() {
    (0, _classCallCheck3.default)(this, CookieStorage);
  }

  (0, _createClass3.default)(CookieStorage, null, [{
    key: '_getKeys',
    value: function _getKeys() {
      return (0, _keys2.default)(_jsCookie2.default.get() || {});
    }
  }, {
    key: 'clear',
    value: function clear(options) {
      this._getKeys().forEach(function (key) {
        return _jsCookie2.default.remove(key, options);
      });
    }
  }, {
    key: 'getItem',
    value: function getItem(key) {
      return _jsCookie2.default.get(key) || null;
    }
  }, {
    key: 'getJSON',
    value: function getJSON(key) {
      try {
        return _jsCookie2.default.getJSON(key) || null;
      } catch (e) {
        return this.getItem(key);
      }
    }
  }, {
    key: 'key',
    value: function key(index) {
      return this._getKeys()[index] || null;
    }
  }, {
    key: 'setItem',
    value: function setItem(key, data, options) {
      _jsCookie2.default.set(key, data, options);
    }
  }, {
    key: 'removeItem',
    value: function removeItem(key, options) {
      _jsCookie2.default.remove(key, options);
    }
  }, {
    key: 'length',
    get: function get() {
      return CookieStorage._getKeys().length;
    }
  }]);
  return CookieStorage;
}();

var StorageProxy = function () {
  function StorageProxy(storageType) {
    (0, _classCallCheck3.default)(this, StorageProxy);

    if (typeof Storage === 'undefined') {
      this._storage = CookieStorage;
      return;
    }

    switch (storageType) {
      case StorageType.SESSION_STORAGE:
        this._storage = window.sessionStorage;
        break;
      case StorageType.COOKIE_STORAGE:
        this._storage = CookieStorage;
        break;
      case StorageType.LOCAL_STORAGE:
      default:
        this._storage = window.localStorage;
    }
  }

  (0, _createClass3.default)(StorageProxy, [{
    key: '_createUserKey',
    value: function _createUserKey(key, username) {
      return username ? username + '_' + key : key;
    }
  }, {
    key: 'clear',
    value: function clear(options) {
      this._storage.clear(options);
    }
  }, {
    key: 'getJsonItem',
    value: function getJsonItem(key, username) {
      var userKey = this._createUserKey(key, username);

      if ((0, _isFunction2.default)(this._storage.getJSON)) return this._storage.getJSON(userKey);

      var data = this._storage.getItem(userKey);

      try {
        return JSON.parse(data);
      } catch (e) {
        return data;
      }
    }
  }, {
    key: 'getItem',
    value: function getItem(key, username) {
      return this._storage.getItem(this._createUserKey(key, username));
    }
  }, {
    key: 'setItem',
    value: function setItem(key, data, username, options) {
      if (!(this._storage instanceof CookieStorage) && (typeof data === 'undefined' ? 'undefined' : (0, _typeof3.default)(data)) === 'object') {
        data = (0, _stringify2.default)(data);
      }
      this._storage.setItem(this._createUserKey(key, username), data, options);
    }
  }, {
    key: 'removeItem',
    value: function removeItem(key, username, options) {
      this._storage.removeItem(this._createUserKey(key, username), options);
    }
  }, {
    key: 'key',
    value: function key(index) {
      return this._storage.key(index);
    }
  }, {
    key: 'length',
    get: function get() {
      return this._storage.length;
    }
  }]);
  return StorageProxy;
}();

exports.default = StorageProxy;
//# sourceMappingURL=StorageProxy.js.map